module.exports = __webpack_public_path__ + "media/images/pages/thermo/home-care-a310cc2073ad47ff86e18944b101fd85.jpg";